import { aboutData } from '@/mocks/anime';

export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {aboutData.title}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            了解51动漫网的发展历程与服务理念
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-5xl mx-auto">
          <div className="flex-shrink-0 w-full max-w-[400px]">
            <div className="rounded-2xl overflow-hidden border border-background-200/60">
              <img
                src={aboutData.image}
                alt="51动漫网品牌形象"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          <div className="flex-1">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8">
              {aboutData.stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-50 rounded-xl border border-background-200/60 p-4 text-center"
                >
                  <div className="font-heading text-2xl md:text-3xl font-bold text-primary-500 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-600">{stat.label}</div>
                </div>
              ))}
            </div>
            <div className="text-foreground-700 text-sm leading-relaxed space-y-4">
              {aboutData.desc.split('\n\n').map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}